// Module
var code = "<div class=\"header {{section}}Header\"> <div class=\"sectionText\"> <i class=\"{{sectionicon}}\" aria-hidden=\"true\"></i><span class=\"headerText\">{{sectiontitle}}</span> <button class=\"mat-icon-button pendo-opener\" ng-if=\"!hidependo\"><i class=\"material-icons\">info</i></button> </div> </div> ";
// Exports
module.exports = code;